import { api } from '@/lib/api/client';

export type Rating = 'up' | 'down';

export interface Feedback {
  id: string;
  vertexSessionId: string;
  messageRef: string;
  rating: Rating;
  reasons?: string[];
  note?: string;
  createdAt: string;
}

export interface FeedbackSubmit {
  vertexSessionId: string;
  messageRef: string;
  rating: Rating;
  reasons?: string[];
  note?: string;
}

/** The caller's feedback in one conversation. */
export function listSessionFeedback(vertexSessionId: string, signal?: AbortSignal): Promise<Feedback[]> {
  return api.get<Feedback[]>('/feedback', { vertexSessionId, limit: 200 }, signal);
}

/** One rating per answer per person: submitting again replaces it. */
export function submitFeedback(body: FeedbackSubmit): Promise<Feedback> {
  return api.post<Feedback>('/feedback', body);
}

/** "What was wrong?" chips (Austin's concept). */
export const DOWN_REASONS = [
  'Wrong number',
  'Wrong document',
  'Missing citation',
  'Out of date',
  "Didn't answer the question",
  'Too long',
] as const;
